import { FormInput } from '../../components/forms/input/FormInput'
import { toAbsoluteUrl } from '../../utils/toAbsolutePath'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Alert } from '../../components/alerts/Alert'
import { TSesionForm, useSesionForm } from './models'
import { useDispatch } from 'react-redux'
import { AppConstantes } from '../../utils/Constantes'
import {
  useIniciarSesionMutation,
  useRecuperarDatosUsuarioQuery,
} from '../../redux/api/autenticacion.api'
import { setTokens, setUsuario } from '../../redux/slices/autenticacion/autenticacion.slice'
import { setItemsLocalStorage } from '../../utils/StorageUtil'
import { FormInputPassword } from '../../components/forms/input/FormInputPassword'

export const IniciarSesion = () => {
  const dispatch = useDispatch()
  const [showAlert, setShowAlert] = useState(<></>)
  const [iniciarSesion, { isLoading, isSuccess }] = useIniciarSesionMutation()
  const { data: dataUsuario, isSuccess: isSuccessUsuario } = useRecuperarDatosUsuarioQuery(null, {
    skip: !isSuccess,
  })
  const formSesion = useSesionForm()
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = formSesion

  useEffect(() => {
    if (isSuccessUsuario) {
      dispatch(setUsuario(dataUsuario))
    }
  }, [isSuccessUsuario])

  const onSubmit = (data: TSesionForm) => {
    iniciarSesion(data)
      .unwrap()
      .then((resp) => {
        setItemsLocalStorage([
          { key: AppConstantes.ACCESS_TOKEN, value: resp.accessToken },
          { key: AppConstantes.REFRESH_TOKEN, value: resp.refreshToken },
        ])
        dispatch(setTokens(resp))
      })
      .catch((err) => {
        if (err.status === 400) {
          setShowAlert(
            <Alert mensaje='Correo electrónico y/o contraseña inválidos.' color='danger' border />
          )
        } else {
          setShowAlert(<Alert mensaje='La solicitud es inválida.' color='danger' border />)
        }
      })
  }

  return (
    <>
      <div
        className='h-100 w-100'
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className='w-lg-500px bg-white rounded shadow-sm  mx-auto'>
          <div className='p-10'>
            <div className='d-flex justify-content-center'>
              <img
                alt='Logo'
                className='h-150px logo'
                src={toAbsoluteUrl('/media/logos/veolia-logo.png')}
              />
            </div>
            <div>
              <div className='text-center py-4'>
                <h1 className='pb-5'>Iniciar sesión</h1>
                <div className='text-gray-600 fs-4 fw-bold pb-2'>
                  Por favor, introduce tus datos para iniciar sesión.
                </div>
                {showAlert}
              </div>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='py-2'>
                  <FormInput
                    nombreCampo='username'
                    register={register}
                    tipo='email'
                    isObligatorio={true}
                    placeholder='ejemplo@mail.com'
                    errors={errors}
                    nombre='Correo electrónico'
                  />
                </div>
                <div className='py-2'>
                  <FormInputPassword
                    nombre='Confirmar contraseña'
                    nombreCampo='password'
                    register={register}
                    placeholder='Contraseña'
                    isObligatorio={true}
                    errors={errors}
                    className='flex-grow-1'
                  />
                </div>
                <div className='py-5'>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary p-5 fs-3 w-100'
                    data-kt-indicator={isLoading ? 'on' : 'off'}>
                    <span className='indicator-label'>Iniciar sesión</span>
                    <span className='indicator-progress'>
                      Cargando...{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  </button>
                </div>
              </form>
              <div className='separator my-5'></div>
              <div className='d-flex justify-content-center fs-4'>
                <Link to={`/restablecer/`}>¿Olvidaste tu contraseña?</Link>
              </div>
            </div>
          </div>
          <div className='text-dark order-1 order-md-1 text-center py-3 mt-3'>
            <small className='text-muted ms-3'>v{process.env.REACT_APP_VERSION}</small>
          </div>
        </div>
      </div>
    </>
  )
}
